export default __webpack_public_path__ + "static/media/image-2.3ac48a5a.jpg";